import { useState } from 'react'

import { ClientError } from '@tribeplatform/gql-client'
import { useResendVerificationCode as useResendCodeSdkHook } from '@tribeplatform/react-sdk/hooks'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

const onError = (message?: string) => {
  toast({
    title: 'Could not send verification email',
    description: message || 'Something went wrong. Please try again later.',
    status: 'error',
  })
}

export const useResendVerificationCode = (): {
  onResend: () => Promise<void>
  resendIsLoading?: boolean
  showResend?: boolean
} => {
  const { mutateAsync: resendCode, isLoading: resendIsLoading } =
    useResendCodeSdkHook()
  const [showResend, setShowResend] = useState(true)

  const onResend = async () => {
    try {
      const result = await resendCode()

      if (result?.status === 'succeeded') {
        setShowResend(false)
        toast({
          title: 'Verification email sent',
          description:
            "Please check your spam if you couldn't find the email in your inbox.",
          status: 'neutral',
        })
      } else {
        onError()
      }
    } catch (e) {
      const message = (e as ClientError)?.response?.errors
        ?.map(e => e.message)
        ?.join('\n')
      onError(message)
    }
  }

  return {
    onResend,
    resendIsLoading,
    showResend,
  }
}
